module.exports = __webpack_public_path__ + "img/71.49366698.png";